<template>
  <div>
    <ClientConclusionFunctionalForm
        v-if="(userCanAdd || userCanEdit) && showForm"
        :establishment="establishment"
        :functionals="functionals"
        v-on:submit="submitForm"
        v-on:cancel="closeForm"/>

    <div class="mb-5">
      <div class="py-3 px-4 border bg-light font-weight-bold text-primary position-relative">
        Функциональные состояния

        <div
          v-if="userCanAdd"
          class="position-absolute"
          style="right:10px;top:8px;">
          <button
              class="btn btn-primary"
              @click="showForm = true">
            Новое функциональное состояния
          </button>
        </div>
      </div>

      <ClientConclusionFunctionalList
          v-on:select="selectEstablishment"
          :items="current" />

      <div
          @click="showPast =! showPast"
          class="py-3 px-4 border-left border-right border-bottom bg-light font-weight-bold text-primary cursor-pointer">
        <u>История функциональных состояний</u>
      </div>

      <ClientConclusionFunctionalList
          v-if="showPast"
          v-on:select="selectEstablishment"
          :items="past" />
    </div>
  </div>
</template>

<script>
import ClientConclusionFunctionalList from './functional/List';
import ClientConclusionFunctionalForm from './functional/Form';
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientConclusionFunctionals',

  components: {ClientConclusionFunctionalList, ClientConclusionFunctionalForm},

  props: ['functionals', 'establishments', 'submitFunctionalEstablishment', 'userCanAdd', 'userCanEdit'],

  data() {
    return {
      showPast: false,
      establishmentId: null,
      showForm: false,
    };
  },

  computed: {
    data() {
      const data = this.establishments.map(e => {
        const {id, note, dateFrom, dateTo, createdBy} = e;
        const functional = this.functionals.find(f => f.id === e.functional);

        return {id, dateFrom, dateTo, note, functional, createdBy};
      });

      data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime());

      return data;
    },

    past() {
      return this.data.filter(i => i.dateTo instanceof Date);
    },

    current() {
      return this.data.filter(i => !(i.dateTo instanceof Date));
    },

    establishment() {
      return this.establishments.find(i => i.id === this.establishmentId);
    },
  },

  methods: {
    selectEstablishment(id) {
      if (!this.userCanEdit) {
        return false;
      }

      this.showForm = true;
      this.establishmentId = id;
    },

    closeForm() {
      this.showForm = false;
      this.establishmentId = null;
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },

    async submitForm(data) {
      await this.submitFunctionalEstablishment(data);

      this.closeForm();
    },
  },
};
</script>
